import defaultFetchServiceOverride from "app/common/services/salesFetchService";

import { createCrmEnrichmentAPIService } from "../../../../services/api/factory";

const sfEnrichmentApiService = createCrmEnrichmentAPIService(defaultFetchServiceOverride, "salesforce");

export default sfEnrichmentApiService;
